<template>
  <div
    :class="[
      'page-view',
      full ? 'flex-expend' : '',
      full && direct ? 'flex-' + (direct == 'horizontal' ? 'col' : 'row') : '',
    ]"
  >
    <div class="global-back">
      <el-button
        v-if="canBack && !embeded"
        :icon="
          hooks && hooks.style && hooks.style.icon
            ? hooks.style.icon
            : 'el-icon-back'
        "
        size="small"
        plain
        :type="hooks && hooks.style ? hooks.style.type : null"
        class="button-segment"
        @click="goBack"
        >{{ hooks && hooks.style ? hooks.style.txt : "返回" }}</el-button
      >
      <slot name="pending-buttons"></slot>
    </div>
    <slot :class="[full ? 'flex-expend' : '']"></slot>
  </div>
</template>

<script>
export default {
  props: {
    full: {
      default: Boolean,
      default: false,
    },
    direct: {
      type: String,
    },
    canBack: {
      type: Boolean,
      default: false,
    },
    hooks: {
      type: Object,
    },
    customeRoadMap: {
      type: Array,
    },
    embeded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBack() {
      if (this.hooks && this.hooks.beforeGoback) {
        if (!this.hooks.beforeGoback()) return;
      }
      if (this.hooks && this.hooks.backHandler) {
        this.hooks.backHandler();
      } else {
        this.$router.go(-1);
      }

      if (this.hooks && this.hooks.afterGoback) {
        this.hooks.afterGoback();
      }
    },
  },
  mounted() {
    if (!this.embeded) {
      this.$store.dispatch("setRoadMap", this.customeRoadMap);
      this._unwatch = this.$watch("customeRoadMap", {
        handler(newValue) {
          this.$store.dispatch("setRoadMap", newValue);
        },
      });
    }
  },
  destroyed() {
    if (this._unwatch) {
      this._unwatch();
      this.$store.dispatch("setRoadMap", null);
    }
  },
};
</script>

<style lang="scss">
.page-view {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  .global-back {
    display: block;
    z-index: 888;
    right: 20px;
    top: 9px;

    position: absolute;

    > * {
      float: right;
      margin-left: 6px;
    }
  }

  .el-button--danger.is-plain:active {
    background: #fff;
    border-color: #fbc4c4;
    color: #f56c6c;
    outline: 0;
  }

  .el-button--danger.is-plain:focus,
  .el-button--danger.is-plain:hover {
    background: #fff;
    border-color: #fbc4c4;
    color: #f56c6c;
  }

  .el-button--danger.is-plain.is-disabled,
  .el-button--danger.is-plain.is-disabled:active,
  .el-button--danger.is-plain.is-disabled:focus,
  .el-button--danger.is-plain.is-disabled:hover {
    color: #f9a7a7;
    background-color: #fef0f0;
    border-color: #fde2e2;
  }
}
</style>